<template>
  <div v-if="this.$get(this.$store, 'state.permissions.9.allow')">
    <div class="userconfig-container" v-if="!getDataById">
      <br />
      <div class="user-table-container">
        <b-list-group>
          <b-list-group-item v-for="(field, index) in fields" :key="index">
            <div class="d-flex w-100 justify-content-between informations-item-title" style="font-size:.5rem">
              <h5 class="mb-2">{{ field.label }}</h5>
            </div>
            <div>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'name'">
                <b-form-input type="text" :placeholder="field.label" v-model="user[field.key]"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'company_name'">
                <b-form-input type="text" :placeholder="field.label" v-model="user[field.key]"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'email'">
                <b-form-input type="text" :placeholder="field.label" v-model="user[field.key]"
                  oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'role_id'">
                <b-form-select :options="roles" value-field="id" text-field="desc" v-model="user[field.key]"
                  class="list-menu"></b-form-select>
              </p>
              <p class="mb-0" style="font-size: .7rem" v-if="field.key == 'status'">
                <b-form-select :options="[
                  { value: 0, text: 'Tidak Aktif' },
                  { value: 1, text: 'Aktif' },
                ]" v-model="user[field.key]" class="list-menu"></b-form-select>
              </p>
            </div>
          </b-list-group-item>
        </b-list-group>
        <div v-if="
          user.role_id == headHseRole() ||
          user.role_id == hseRole() ||
          user.role_id == kttRole()
        " style="padding: 10px">
          <div>Additional Roles for HSE</div>
          <div class="mb10">
            <treeselect :multiple="true" :options="gemsOptions" placeholder="Select Company..."
              v-model="gemsSelectValue" />
          </div>
        </div>
      </div>
      <div class="legaledit-btn">
        <b-button class="btn-edit mr-1" @click="cancelEdit">Cancel</b-button>
        <b-button class="btn-edit mr-1" @click="deleteUser">Delete</b-button>
        <b-button class="btn-edit mr-1" @click="saveEdit">Save</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '../services/config'

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'company_name', label: 'Company Name' },
        { key: 'email', label: 'Email' },
        { key: 'role_id', label: 'Role' },
        { key: 'status', label: 'Status' },
      ],
      user: {
        name: null,
        email: null,
        role_id: null,
        status: null,
        company_name: null,
      },
      roles: [],
      gemsValue: null,
      gemsSelectValue: null,
      gemsOptions: [],
    }
  },
  async created() {
    await this.getGemsCompanyCode()
    await this.getHSECompany()
  },
  computed: {
    getDataById() {
      this.getData()
      this.getUserRole()
    },
  },
  methods: {
    headHseRole() {
      const roles = this.roles


      let hse = roles.filter(i => i.desc.toLowerCase() == 'head hse')

      if (hse.length > 0) {

        return hse[0].id
      }

      return 'wkwkwk'
    },
    hseRole() {
      const roles = this.roles


      let hse = roles.filter(i => i.desc.toLowerCase() == 'hse')

      if (hse.length > 0) {

        return hse[0].id
      }

      return 'wkwkwk'
    },
    kttRole() {
      const roles = this.roles


      let ktt = roles.filter(i => i.desc.toLowerCase() == 'ktt hse')

      if (ktt.length > 0) {
        return ktt[0].id
      }

      return 'wkwkwk'
    },
    async deleteUser() {
      let id = this.$route.params.id
      try {
        if (confirm('Apakah yakin menghapus user ini?')) {
          const { data } = await axios({
            method: 'DELETE',
            url: `${api}/api/v1/user/${id}`,
            headers: {
              'Content-Type': 'application/json',
            },
          })
          if (data && data.status == 'success') {
            await this.$router.push({ path: '/user-role' })
            await this.$store.commiit('SET_NOTIF', data.status)
          }
        }
      } catch (error) { }
    },
    cancelEdit() {
      this.$router.push({ path: '/user-role' })
    },
    async saveEdit() {
      let user = this.user
      if (
        user.role_id == this.headHseRole() ||
        user.role_id == this.hseRole() ||
        user.role_id == this.kttRole()
      ) {
        user.companies = this.gemsSelectValue
      }
      const self = this
      let id = this.$route.params.id
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${api}/api/v1/user/${id}`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: user,
        })
        if (data && data.status == 'success') {
          await self.$router.push({ path: '/user-role' })
          await self.$store.commit('SET_NOTIF', data.status)
        }
      } catch (error) { }
    },
    getData() {
      const self = this
      let id = this.$route.params.id
      axios({
        method: 'GET',
        url: `${api}/api/v1/user/user-by-id/${id}`,
      })
        .then(({ data }) => {
          self.user = {
            name: data.data.name,
            email: data.data.email,
            role_id: data.data.role_id,
            status: data.data.status,
            company_name: data.data.company_name,
          }
        })
        .catch(error => {
        })
    },
    getUserRole() {
      const self = this
      let id = this.$route.params.id
      axios({
        method: 'GET',
        url: `${api}/api/v1/user/roles`,
      })
        .then(({ data }) => {
          self.roles = data.data
        })
        .catch(error => {

        })
    },
    async getGemsCompanyCode() {
      try {
        const url = `${api}/api/v1/dashboard/company`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.gemsOptions = await data.data.map(item => {
            return {
              id: item.kode,
              label: `${item.kode} - ${item.nama_perusahaan}`,
            }
          })

          this.gemsOptions = await this.gemsOptions.filter(
            item => item.id != 2000
          )
        }
      } catch (error) {

      }
    },
    async getHSECompany() {
      let id = this.$route.params.id
      try {
        const url = `${api}/api/v1/user/hse-company/${id}`
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          this.gemsSelectValue = await data.data.map(item => {
            return item.kode
          })
        }
      } catch (error) {

      }
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/legaledit.scss';
</style>
